import PermIdentityRoundedIcon from '@mui/icons-material/PermIdentityRounded';
// import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import logo from "../assets/mayi_global_dark.png"
import DashboardIcon from "../assets/adminSidebar/Dashboard.svg"
import CancelIcon from '@mui/icons-material/Cancel';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { updateListSelect, updateOtpVerifyPopup } from '../redux/user_reducer';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Box,Typography,Collapse,Avatar } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { updateSideBar } from '../redux/active_bar';
import { useMediaQuery } from "react-responsive"
import Dashboard from '../modules/dashboard';
import profile from "../assets/User.svg"
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import passwordChange from "../assets/Login.svg"
import order from "../assets/Clipboard.svg"
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import wallet from "../assets/Vector.svg"
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import { jwtDecode } from 'jwt-decode';
import { TranslateText } from '../utils/googletranslator';
import switcIcon from "../assets/switch_Icon.svg"
import { updateFirstName, updateLastName, updateEmail, updateRole, updateId, updateAllAddress,updateMemberResponse, updateUserName, updateMobile,updateWhatsapp, updateAccumulated,updateGetBank,updateWithdrawRequest,updateMembership,updateConrtol, updatePlanSubscribed, updateMultiple, updateMultipleAccount, updateSwitchedAccount,updateProfile, updateIsDetailsLoading, updateIsProfileReloaded } from "../redux/user_reducer"
//  import { updateOtpVerifyPopup } from '../redux/user_reducer';
// import { useHistory } from 'react-router-dom';
import CustomAxios from '../utils/CustomAxios';
const SideBarList = () => {
    const admin =useSelector(state=>state.user.role)
    const isMobile = useMediaQuery({ maxWidth: 600 });
    const [selected, setSelected] = useState();
    const role = useSelector(state => state.user.role)
    const list_select = useSelector(state => state.user.listitem)
    const member=useSelector(state=>state.user.member)
    const multiple=useSelector(state=>state.user.multiple)
    const multipleAccount=useSelector(state=>state.user.multipleAccount)
    const [accountExpand,setAccoutExpand]=useState(false) 
    const dispatch=useDispatch()
    const navigate=useNavigate()

    const location = useLocation()
    const allAccess=useSelector(state=>state.user.accessControl)
    const authToken=localStorage.getItem('authtoken');
//   const res= authToken && jwtDecode(authToken)
//   const refreshToken=localStorage.getItem('refreshToken');
//   let  username = useSelector(state => state.user.username)
//   const role = useSelector(state => state.user?.role)
//   const location=useLocation()
  const control=useSelector(state=>state.user.control)
    const accessControl=useSelector(state=>state.user.accessControl)
    let [pages,setPages]=useState([])
    let [module,setModule]=useState([])
    // const history=useHistory()
    const logout=()=>{
        const localanguage=localStorage.getItem("language")?localStorage.getItem("language"):"en"
        ;['authtoken','refreshToken','address','user','redirect','package','signupSessionId','isVerified'].forEach((storageKey) => {
            localStorage.removeItem(storageKey)
        })
        localStorage.setItem('language',localanguage)
        window.location.replace(admin ? '/login' : '/')
       
        
    }
    let switchUser= async(acc)=>{
        dispatch(updateIsDetailsLoading(true))
        try{
            const planResponse = await CustomAxios.get(`active_plan/${acc.id}`)
            if (planResponse.data.message=="Plan activated successfully"){
                const payload = {user_id: acc.id}
                   
                    if (acc.id){
                    // On dashboard, we need embedded lvl2 members for TeamBoard auto-preexpand.
                    // So don't call legacy get_details/ during switching; use dashboard-details/ instead.
                    const isProfileRoute = location.pathname === "/profile"
                    const detailsEndpoint =
                        location.pathname === "/dashboard" ||
                        location.pathname === "/my_networth"
                            ? "dashboard-details/"
                            : (location.pathname === "/products" || location.pathname.startsWith("/product_details/"))
                                ? "profile-details/"
                            : "get_details/"
                    const detailsRequest = isProfileRoute
                        ? Promise.resolve({ data: null })
                        : CustomAxios.post(detailsEndpoint, payload)
                    const [detailsResponse, switchingResponse] = await Promise.all([
                        detailsRequest,
                        CustomAxios.get(`account_switching/${acc.id}`)
                    ]);
                    if (isProfileRoute) {
                        localStorage.setItem("authtoken", switchingResponse.data.access_token)
                        localStorage.setItem("refreshToken", switchingResponse.data.refresh_token)
                        dispatch(updateId(acc.id))
                        dispatch(updateIsProfileReloaded(true))
                        return
                    }
                        dispatch(updateFirstName(detailsResponse.data.user.first_name))
                        dispatch(updateLastName(detailsResponse.data.user.last_name))
                        dispatch(updateEmail(detailsResponse.data.user.email))
                        dispatch(updateUserName(detailsResponse.data.user.username))
                        dispatch(updateMobile(detailsResponse.data.user.mobileno))
                        // dispatch(updateRole(decode.role))
                        dispatch(updateWhatsapp(detailsResponse.data.user.whatsapp))
                        dispatch(updateId(detailsResponse.data.user.id))
                        dispatch(updateMemberResponse(detailsResponse.data))
                    // dashboard-details/ does not include profile/bank/withdraw payloads
                    if (detailsResponse.data.att?.original) {
                        dispatch(updateProfile(detailsResponse.data.att.original))
                    }
                    if (detailsResponse.data.accumulated != null) {
                        dispatch(updateAccumulated(detailsResponse.data.accumulated))
                    }
                    if (detailsResponse.data.bankdetails != null) {
                        dispatch(updateGetBank(detailsResponse.data.bankdetails))
                    }
                    if (detailsResponse.data.withdrawRequest != null) {
                        dispatch(updateWithdrawRequest(detailsResponse.data.withdrawRequest))
                    }
                    // user.member exists on both get_details/ and dashboard-details/
                    dispatch(updateMembership(detailsResponse.data.user.member))
                    if (detailsResponse.data.subscribedplan != null) {
                        dispatch(updatePlanSubscribed(detailsResponse.data.subscribedplan))
                    }
                        dispatch(updateMultiple(detailsResponse.data.multiple))
                        dispatch(updateMultipleAccount(detailsResponse.data.multipleAccounts))
                        dispatch(updateSwitchedAccount(detailsResponse.data.multipleAccounts.filter(a=>a.id===acc.id)))
                        localStorage.setItem("authtoken", switchingResponse.data.access_token)
                        localStorage.setItem("refreshToken", switchingResponse.data.refresh_token)  
                    }
                }
                else{
                    dispatch(updateId(acc.id))
                    localStorage.setItem("package",planResponse.data.package)
                    // No active plan - redirect to payment page
                    navigate("/payment-page")
                }
        } catch(error) {
                console.log(error)
                // On error, still redirect to payment page
                navigate("/payment-page")
        } finally {
            dispatch(updateIsDetailsLoading(false))
        }
    }
    useEffect(()=>{
        // console.log("??????????????????authtoken",authToken,accessControl)
           if (authToken){
            const decode=jwtDecode(authToken)
            // console.log("??????????????????????decoded line up",decode.control)
            const access=accessControl.filter(item=>item.role==decode.control)[0]
            // console.log("????????????????????access",authToken,decode.control)
            // decode.control
            // console.log(access.access)
            let module=[]
            let pages=[]
            access?.access?.map(item=>{
                // console.log(item,typeof(item))
                if(typeof(item)=='object' ){
                   module.push(Object.keys(item)[0])
                   pages=[...pages,...Object.values(item)[0]]
                }
                else if(typeof(item)=='string' ){
                    pages.push(item)
        
                }
            })
            // console.log("??????????????? params",location,id)
            setPages(pages)
            setModule(module)
           }
              
        },[])
    useEffect(()=>{
        // console.log(location.pathname)
        setSelected(location.pathname)
        dispatch(updateListSelect(location.pathname))
    },[])
    const handleListItemClick = (e, list) => {
        e.preventDefault();
        // console.log(list)
        setSelected(list);
        dispatch(updateListSelect(list))
        navigate(list)
    };
    const capitalize = (str) => {
        return str?.split(' ').map(word => word?.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }
    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    return(
    <Box
        sx={{ width:"100%" ,}}
        role="presentation"
        onClick={()=>dispatch(updateSideBar(false))}
        onKeyDown={()=>dispatch(updateSideBar(false))}
    >
        {/* {isMobile&&<>
        <Box sx={{ padding: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box component="img" sx={{width:"100px" }} src={logo} />
            
            <CancelIcon sx={{color:'grey.500'}} />
            
        </Box>
        <Divider /></>} */}
         <List>
            { pages.includes('/dashboard')&&
            <ListItem  disablePadding sx={{"&:hover":{color:"primary.light"}, color:list_select=="/dashboard"?"primary.light":"grey.900",borderLeft:list_select=="/dashboard"?"3px solid":"3px solid",borderColor:list_select=="/dashboard"?"primary.light":"#fff" ,height:"30px",padding:"20px 0px"}} >
                <ListItemButton component={Link} to="/dashboard" sx={{height:"30px","&:hover":{color:"primary.light"},}} onClick={(e)=>handleListItemClick(e, '/dashboard')}>
                    <ListItemIcon sx={{minWidth:"0px",padding:"18px"}}>
                    <DashboardOutlinedIcon color={selected=="/dashboard"?'primary.light':'grey.200'} />
                    {/* <img src={DashboardIcon} style={{width:"20px", height:"20px"}}/> */}
                        </ListItemIcon>
                    <ListItemText sx={{}} primary={<TranslateText>Dashboard</TranslateText>} />
                </ListItemButton>
            </ListItem>}
            {pages.includes('/profile')&&
            <ListItem  disablePadding sx={{"&:hover":{color:"primary.light"}, color:list_select=="/profile"?"primary.light":"grey.900",borderLeft:list_select=="/profile"?"3px solid ":"3px solid",borderColor:list_select=="/profile"?"primary.light" :"#fff",height:"30px",padding:"20px 0px"}} >
                <ListItemButton component={Link} to="/profile" sx={{height:"30px","&:hover":{color:"primary.light"},}} onClick={(e)=>handleListItemClick(e, '/profile')}>
                    <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                    <img src={profile} style={{width:"20px", height:"20px", color:selected=="/profile"?'primary.light':'grey.200'}}/> 
                        </ListItemIcon>
                    <ListItemText primary={<TranslateText>Profile</TranslateText>} />
                </ListItemButton>
            </ListItem>}
            <ListItem  disablePadding sx={{"&:hover":{color:"primary.light"}, color:list_select=="/password-change/change"?"primary.light":"grey.900",borderLeft:list_select=="/password-change/change"?"3px solid ":"3px solid" ,borderColor:list_select=="/password-change/change"?"primary.light":"#fff",height:"30px",padding:"20px 0px" }}>
                <ListItemButton component={Link} to="/password-change/change" sx={{height:"30px","&:hover":{color:"primary.light"},}} onClick={(e)=>handleListItemClick(e, '/password-change/change')} >
                <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                    <img src={passwordChange} style={{width:"20px", height:"20px", color:selected=="/password-change/change'"?'primary.light':'grey.200'}}/> 
                        </ListItemIcon>
                    <ListItemText primary={<TranslateText>Change Password</TranslateText>} />
                </ListItemButton>
            </ListItem>
           {/* { role=="user" &&
            <ListItem disablePadding sx={{ color:list_select=="/checkout"?"primary.light":"grey.900",borderLeft:list_select=="/checkout"?"3px solid":"3px solid",borderColor:list_select=="/checkout"?"primary.light":"#fff" ,height:"30px",padding:"20px 0px" }}  >
                <ListItemButton component={Link} to="/checkout" sx={{height:"30px"}} onClick={(e)=>handleListItemClick(e, '/checkout')}>
                <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                <ShoppingBagOutlinedIcon />
                        </ListItemIcon>
                    <ListItemText primary={"Checkout"}  />
                </ListItemButton>
            </ListItem>} */}
            {pages.includes('/my_networth') &&
            <ListItem disablePadding sx={{"&:hover":{color:"primary.light"}, color:list_select=="/my_networth"?"primary.light":"grey.900",borderLeft:list_select=="/my_networth"?"3px solid":"3px solid",borderColor:list_select=="/my_networth"?"primary.light":"#fff" ,height:"30px",padding:"20px 0px" }}  >
                <ListItemButton component={Link} to="/my_networth" sx={{height:"30px","&:hover":{color:"primary.light"},}} onClick={(e)=>handleListItemClick(e, '/my_networth')}>
                <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                    <img src={wallet} style={{width:"20px", height:"20px", color:selected=="/my_networth"?'primary.light':'grey.200'}}/> 
                        </ListItemIcon>
                    <ListItemText primary={<TranslateText>My Networth</TranslateText>}  />
                </ListItemButton>
            </ListItem>}
            {(role=="user"||role=='sc') &&pages.includes('/orderstatus') &&
            <ListItem disablePadding sx={{"&:hover":{color:"primary.light"}, color:list_select=="/orderstatus"?"primary.light":"grey.900",borderLeft:list_select=="/orderstatus"?"3px solid":"3px solid",borderColor:list_select=="/orderstatus"?"primary.light":"#fff" ,height:"30px",padding:"20px 0px" }}  >
                <ListItemButton component={Link} to="/orderstatus" sx={{height:"30px",textDecoration:"none","&:hover":{color:"primary.light"},}} onClick={(e)=>handleListItemClick(e, '/orderstatus')}>
                <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                    <img src={order} style={{width:"20px", height:"20px", color:selected=="/orderstatus"?'primary.light':'grey.200'}}/> 
                        </ListItemIcon>
                    <ListItemText primary={<TranslateText>Orders</TranslateText>}  />
                </ListItemButton>
            </ListItem>}
            {
                    multiple&&<ListItem disablePadding sx={{"&:hover":{color:"primary.light"}, color:accountExpand?"primary.light":"grey.900",borderLeft:accountExpand?"3px solid":"3px solid",borderColor:accountExpand?"primary.light":"#fff" ,height:"30px",padding:"20px 0px" }}>
               
                    <ListItemButton sx={{ color: "grey.900",display:"flex",alignItems:"center",height:"30px" }} onClick={(e) => {e.stopPropagation(); setAccoutExpand(!accountExpand);dispatch(updateListSelect())}}>
                    <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                    <img src={switcIcon} style={{width:"20px",}}/> 
                                    {/* <PeopleOutlineIcon sx={{color:"#000",minWidth:"0px"}} /> */}
                                </ListItemIcon>
                                <ListItemText sx={{fontWeight:accountExpand ? '700':'400'}} primary="Switch Account" />
                                {accountExpand ? <ExpandLess /> : <ExpandMore />}
                            </ListItemButton>
                            </ListItem>
                }
            
                    {accountExpand&&
            <Collapse  in={accountExpand} timeout="auto" unmountOnExit>
                {
                    multipleAccount.map(acc=>
                        <List component="div" disablePadding key={acc.id ?? acc.mid ?? acc.username}>
                        <ListItemButton  sx={{ pl: 6, gap:"15px"}} onClick={()=>switchUser(acc)} >
                            <ListItemIcon sx={{minWidth:"20px"}}>
                            {/* <Box component= 'img' sx={{width:"20px"}}    /> */}
                            <Avatar {...stringAvatar(capitalize(acc.first_name) + " " + capitalize(acc.last_name))}  style={{ height:"32px",width:"32px",borderRadius:"16px",background:"linear-gradient(45deg, #00C2FF 10%, #00E3AF 90%)",fontSize:"14px",fontWeight:"700",cursor: "pointer", }} />
                            </ListItemIcon>
                            <ListItemText primary={acc.first_name+" "+acc.last_name}  sx={{ color: "grey.900" }}  />
                        </ListItemButton>
                    </List>
                    )

                }
                        
                       
                    </Collapse>}
            <ListItem disablePadding sx={{"&:hover":{color:"primary.light"},height:"30px",padding:"20px 0px" }}>
                <ListItemButton sx={{height:"30px"}}  onClick={logout}>
                    <ListItemIcon sx={{minWidth:"0px",padding:"20px"}}>
                        <LogoutOutlinedIcon color='primary.dark' />
                    </ListItemIcon>
                    <ListItemText primary={<TranslateText>Logout</TranslateText>} />
                </ListItemButton>
            </ListItem>


        </List>
    </Box>)
}
export default SideBarList
